import { Injectable } from '@angular/core';
import { ResourceStore } from './resource.store';
import { ResourceQuery } from './resource.query';
import { BaseFacade } from '../base/base.facade';
import { ResourceService } from './resource.service';
import { TranslateService } from '@ngx-translate/core';
import { DynamicSchemaFactory } from '../dynamic-schema.factory';
import { Content } from '../../squidex/models/content.model';
import { Observable, of, from } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ResourceFacade extends BaseFacade {
    private static resources: Content[] = [];
    resourcesLoad: Promise<Content[]> = this.reloadResources();
    private static lastCheck:Date = new Date();
    private static minutesToWait: number = 15;


    constructor(
        appResourceService: ResourceService,
        appResourceStore: ResourceStore,
        appResourceQuery: ResourceQuery,
        dynamicSchemaFactory: DynamicSchemaFactory,
        translateService: TranslateService) {
        super(appResourceService,
          appResourceStore,
          appResourceQuery,
          dynamicSchemaFactory.getDynamicSchemaFacade('resource'),
          translateService,
          'resource-facade'
          );

    }

    existLocally(code: string): boolean {
      return ResourceFacade.resources.find(r => r.data.code.iv === code) !== undefined;
    }

    getByCode(code: string, draftMode: boolean = false): Observable<Content> {
      if(ResourceFacade.lastCheck.getTime() + 1000 * 60 * ResourceFacade.minutesToWait < new Date().getTime()) {
        this.resourcesLoad = this.reloadResources();
        ResourceFacade.lastCheck = new Date();
      }

      if(ResourceFacade.resources.length > 0) {
        let resource = ResourceFacade.resources.find(r => r.data.code.iv === code);
        if(resource) {
          return of(resource);
        }
      }

      return from(this.resourcesLoad.then(r => {
        return r.find(r => r.data.code.iv === code);
      }));
    }

    private reloadResources(): Promise<Content[]> {
      return this.getService().getAll().pipe(map(r => {
        ResourceFacade.resources = r.items;
        return r.items;
      })).toPromise();
    }

    flushResources(): void {
      ResourceFacade.resources = [];
      ResourceFacade.lastCheck = new Date();
      this.resourcesLoad = this.reloadResources();
    }
}
